import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_wrkrs_became_disabled_for_a_workrelated_reason'

export const dataPointDefinition = {
  retracedId: 'how_many_wrkrs_became_disabled_for_a_workrelated_reason',
  name: 'How many workers became disabled for a work-related reason?',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-47',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11430,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
